import axios, { type AxiosResponse } from 'axios'
import type { LoginCredentials } from '@/interfaces/LoginCredentials'
import type { ResetPasswordRequest } from '@/interfaces/ResetPasswordRequest'
import type { CompletedCheck } from '@/interfaces/CompletedCheck'
import type { Issue } from '@/interfaces/Issue'
import type { Setting } from './interfaces/Setting'
import {saveAs} from "file-saver";

export class ApiClient {
  async login(loginCredentials: LoginCredentials): Promise<void> {
    return axios.post('token', {
      email: loginCredentials.email,
      password: loginCredentials.password
    })
  }

  async forgotPassword(email: string): Promise<void> {
    return axios.post('user/forgot-password', {
      email: email
    })
  }
  
  async resetPassword(old: string, newPass: string): Promise<void> {
    return axios.post('user/change-password', {
      password: old,
      newPassword: newPass
    })
  }

  async getTodaysChecks(): Promise<AxiosResponse<any>> {
    return axios.get('check/list-todays?d=' + new Date().getTime())
  }

  async saveCheck(completedCheck: CompletedCheck): Promise<void> {
    if (completedCheck.issues == undefined) { completedCheck.issues = []; }
    console.log(completedCheck.issues);
    return axios.post('completedchecks/save', {
      checkid: completedCheck.checkId,
      answers: completedCheck.answers,
      notes: completedCheck.notes,
      issues: completedCheck.issues.map(issue => ({
        severity: issue.severity.toLowerCase() == "high" ? 1 : 0,
        description: issue.description,
        taskId: issue.taskId,
        checkId: issue.checkId,
        meta: {
          categoryId: issue.categoryId ?? null,
          reporterName: issue.reporterName ?? null
        },
        attachments: (issue.attachmentFileIds ?? []).map(fileId => ({ uploadedFileId: fileId }))
      }))
    })
  }

  async saveIssue(issue: Issue): Promise<void> {
    return axios.post('issue/create', {
      id: issue.taskId,
      checkId: issue.checkId,
      taskId: issue.taskId,
      severity: issue.severity,
      description: issue.description,
      categoryId: issue.categoryId ?? null,
      attachmentFileIds: issue.attachmentFileIds ?? null,
      reporterName: issue.reporterName ?? null
    })
  }

  async getIssueCategories(): Promise<AxiosResponse<any>> {
    return axios.get('issue-categories/list')
  }

  async preUploadIssueAttachment(file: Blob, filename: string): Promise<AxiosResponse<any>> {
    const formData = new FormData()
    formData.append('file', file, filename)
    return axios.post('issue/pre-upload-attachment', formData)
  }

  async getNotifications(): Promise<AxiosResponse<any>> {
    return axios.get('notifications/list')
  }

  async getDocuments(folder:string): Promise<AxiosResponse<any>> {
    return axios.get('documents/list?id=' + folder)
  }


  async getDataUrl(id: string, filename: string): Promise<string> {
    const response = await axios.get("/documents/view?id=" + id);
    if (response == null) return "";
    return await response.data;
  }

  async download(id: string, filename: string) {
    await axios.get("/documents/download?id=" + id, {
      responseType: "blob",
    }).then(async (response: any) => {
      if (response == null) return;
      saveAs(response.data, filename);
    })
  }


  async setNotificationsAsSeen(): Promise<void> {
    return axios.post('notifications/setAsSeen')
  }

  async getSettings(): Promise<AxiosResponse<any>> {
    return axios.get('settings')
  }

  async updateSettings(settings: Setting): Promise<void> {
    return axios.post('settings', settings)
  }

  async getLocations(): Promise<AxiosResponse<any>> {
    return axios.get('location/get/all')
  }
  async setLocation(id: string): Promise<void> {
    return axios.post('token/set-location', {
      id: id
    })
  }
}
